import React from 'react'

export const EditDrawerHeading = ({ text, amount }) => {
  return (
    <h4 className="opacity-50 m-0 mt-4">
      {text} {!!amount && <span>({amount})</span>}
    </h4>
  )
}
